import { MmserverApi } from 'api/mmServerApi';
import LocalStorage from './Storage';
import config from '../config';
import createAxisInstance from './createAxisInstance';

const apiConfiguration = {
  username: config.clientId,
  password: config.clientSecret,
  accessToken: getToken,
};

function getToken() {
  return LocalStorage.getItem(config.tokenItemName);
}

export const axi = createAxisInstance;

export default {
  mmServer: new MmserverApi(apiConfiguration, undefined, axi),
};
